import { TableCell } from '@mui/material';
import styled from 'styled-components';
import { Typography, Button, TableWrapperHeader, SimpleTable } from '../../design-system';
import { DashboardHeader } from '../dashboard';
import { formatContainerType, momentTextFormat, showToRoles } from '../../utils';
import { getCache, saveCache } from '../../services';
import { FeeType, SalesFeeGetOneResponse, SalesFeeUpdateModalCache, User } from '../../types';
import { i18n } from '../../i18n';

const SalesFeeTableWrapperHeader = styled(TableWrapperHeader)`
  & > *:nth-child(2) {
    position: sticky;
    right: 0;
  }
`;

export const SalesFeesViewHeader = () => {
  return (
    <DashboardHeader>
      <span />
      <Button size={'medium'} data-color={'white'} to={-1}>
        {i18n.t('button.goBack')}
      </Button>
    </DashboardHeader>
  );
};

interface SalesFeesTableProps {
  data: SalesFeeGetOneResponse['data'];
  feeRecords: SalesFeeGetOneResponse['data']['feeRecords'][number];
  user: User;
  refetch: () => void;
}

export const SalesFeesTable = ({ data, feeRecords, user, refetch }: SalesFeesTableProps) => {
  const handleUpdateClick = () => {
    saveCache<SalesFeeUpdateModalCache>('sales-fee-update-modal', (props) => ({
      ...props,
      id: data.id,
      yard: data.yard,
      activeFee: feeRecords,
      refetch,
    }));

    getCache<SalesFeeUpdateModalCache>('sales-fee-update-modal').open();
  };

  return (
    <SimpleTable
      data={{
        data: feeRecords.containers,
        totalCount: feeRecords.containers.length,
      }}
      filters={() => (
        <SalesFeeTableWrapperHeader align={'right'}>
          <Typography variant={'textL'} weight={'bold'}>
            {i18n.t('label.effectiveDate')}: {momentTextFormat(feeRecords.activationDate, user)}
          </Typography>
          {feeRecords.isActive && !showToRoles(['YARD_COMPANY_VIEWER'], user) && (
            <Button size={'medium'} onClick={handleUpdateClick}>
              {i18n.t('button.update')}
            </Button>
          )}
        </SalesFeeTableWrapperHeader>
      )}
      tableRowProps={(row, i) => ({
        key: 'storage-pricing-table-row' + i,
        onClick: () => {},
      })}
      columns={[
        {
          column: 10,
          headText: () => i18n.t('label.type'),
          body: (row) => (
            <TableCell component={'th'} align={'left'}>
              {formatContainerType(row.type)}
            </TableCell>
          ),
        },
        {
          headText: () => i18n.t('label.fee'),
          bodyText: (row) => `${row.fee}${feeRecords.feeType === FeeType.FIXED ? '$' : '%'}`,
        },
      ]}
    />
  );
};
